import { updateCompanyPermission } from "../data/repository/company.repo";

export const UpdateCompanyPermissionUseCase = async (
  permissions,
  companyId
) => {
  try {
    const resp = await updateCompanyPermission(permissions, companyId);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
